import qs from 'qs';
class API {
  _url = "";
  comment = "";
  type = "";
  query = {};
  _format = false;
  constructor(url,comment,type){
    this._url = url;
    this.comment = comment;
    this.type = type;
    this._format  = false;
  }
  get urlFormat (){
    return this._url + "?" + qs.stringify(this.query,{});
  }
  get url(){
    if (this._format){
      return this.urlFormat;
    }
    return this._url;
  }
  set format(format){
    this._format = format;
  }
}

export function apiKey(url,comment,type = "json"){
  return new API(url,comment,type)
}

export default {
  login: apiKey("/auth/email/login.json",'用户邮件登录',"form"),
  signup: apiKey("/auth/signup.json", "用户注册",'form'),
  logout: apiKey("/auth/logout.json","登出"),
  estimate: apiKey("/estimate.json", "预估费用"),
  checkAddress: apiKey("/pub/check-address.json", "检查输入地址合法性"),
  warehouse: apiKey("/warehouse/list.json","获取仓库列表"),
  priceInsurance: apiKey("/price/insurance.json","获取保险费用"),
  pricePickup: apiKey("/price/pickup.json","获取取件费用"),
  pickupListAval: apiKey("/pub/pickup/list-aval.json","取得fedex取件时间范围"),
  getState: apiKey("/pub/state.json","获取美国所有的洲"),
  orderSave: apiKey("/order/main/save.json", "保存寄出 订单"),
  orderEdit: apiKey("/order/main/edit.json", "保存寄出 订单"),
  orderHistory:apiKey("/order/history.json","根据状态查找出用户所有的订单并返回状态"),
  authForget: apiKey("/auth/forget.json","找回密码，发送邮件","form"),
  authCheckEmailCode: apiKey("/auth/check-email-code.json","提示邮件和验证码是否正确","form"),
  authChangePassword: apiKey("/auth/change-password.json", "根据邮件及验证码，设置新密码","form"),
  userUserInfo: apiKey("/user/userinfo.json","展示用户信息"),
  authSavePwd: apiKey("/auth/save-pwd.json", "修改密码","form"),
  userSaveMail: apiKey("/user/save-mail.json","保存邮箱"),
  userSaveName: apiKey("/user/save-name.json","保存用户名"),
  stripeBindCard: apiKey("/stripe/bind-card.json","绑定信用卡"),
  createTestPaymentIntent: apiKey("/stripe/create-payment-intent.json","绑卡并支付"),
  createPrepaymentIntent: apiKey("/order/bill/create-prepayment-intent.json","创建支付意图，支付同时保存信用卡"),
  savePaymentMethod: apiKey("/stripe/save-payment-method.json","保存支付方式"),
  prepaymentSuccess: apiKey("/order/bill/prepayment-success.json","预付款支付成功"),
  fetchPaymentMethod: apiKey("/stripe/fetch-payment-method.json","获取默认支付方式"),
  removeDefaultPaymentMethod: apiKey("/stripe/remove-default-payment-method.json", "移除默认银行卡"),
  orderUseDefaultCard: apiKey("/stripe/use-default-card.json", "订单绑定默认卡"),
  mailSendCode: apiKey("/mail/send-code.json","发送邮箱验证码"),
  mailVerifyEmail: apiKey("/mail/verify-email.json","校验邮箱"),
  authVerify: apiKey("/auth/has-verify-email.json","检查当前登录用户是否验证邮箱/绑卡"),
  orderMainInfo: apiKey("/order/main/info.json","订单详情 寄出信息"),
  orderMainDraftInfo: apiKey("/order/main/draft-info.json","订单详情 寄出信息"),
  orderExpireTime: apiKey("/order/main/order-expire-time.json","订单详情 过期时间"),
  backExpireTime: apiKey("/order/back/order-expire-time.json","订单详情 过期时间"),
  prepaymentInfo: apiKey("/order/main/info-prepayment.json","订单详情 预付费账单信息"),
  orderStatusLuggage: apiKey("/order/status/luggage.json","根据订单号获取包裹状态Box Status"),
  orderStatusBill: apiKey("/order/status/bill2.json","查询订单支付记录"),
  paymentDetails: apiKey("/order/status/payment-details.json","根据billId获取信用卡信息 Payment details"),
  orderBackSave: apiKey("/order/back/save.json","填写寄回信息"),
  orderBackCancel: apiKey("/order/back/cancel.json","取消寄回预约"),
  backBillInfo: apiKey("/order/back/bill-info.json","寄回账单信息"),
  backBillPay: apiKey("/order/back/bill-pay.json","支付账单"),
  billListFailed: apiKey("/bill/failed-list.json","获取支付失败的账单"),
  billListPayFailed: apiKey("/bill/pay-failed-list.json","支付失败的账单"),
  priceSignatureType: apiKey("/price/signature-type.json","寄回价格"),
  orderBackDeliveryDate: apiKey("/order/back/delivery-start-date.json","获取最早寄回日期"),
  orderBackSendDate: apiKey("/order/back/send-date.json","获取预计出库日期"),
  orderLabelDownload: apiKey("/order/label/download.pdf","下载面单文件"),
  orderBackInfo: apiKey("/order/back/info.json","订单详情 寄回信息"),
  orderBackEdit: apiKey("/order/back/edit.json","编辑寄回信息"),
  orderBackUpdate: apiKey("/order/back/update.json","删除并创建新的寄回信息"),
  orderMainCancel: apiKey("/order/main/cancel.json","/order/main/cancel.json"),
  authGoogle: apiKey("/auth/google/login-page.json", "google授权登录"),
  authFaceBook: apiKey("/auth/facebook/login-page.json","facebook授权登录"),
  authApple: apiKey("/auth/apple/login.json","apple授权登录", 'form'),
  authCheck: apiKey("/auth/nonce/check.json","检查授权结果"),
  bindExistingEmail: apiKey("/user/oauth/bind-existing-email.json","第三方登录绑定已有账号"),
  userCurpwd: apiKey("/user/cur-pwd.json","是否需要输入当前密码")
}
